(function (){
    'use strict';

    angular
        .module('services')
        .service('SeminarsService', SeminarsService);

    SeminarsService.$inject = ['$http', 'API_BASE'];

    function SeminarsService ($http, API_BASE) {
        var service = this;

        service.getAllSeminars = getAllSeminars;

        function getAllSeminars() {
            return $http.get(API_BASE + '/seminars/list');
        }

    }
})();